export default __webpack_public_path__ + "static/Plain-Regular-21a7404673cfd9d11163db1b96ff34c7.woff";